
      module.exports = {
        functional: true,
        render(_h, _vm) {
          const { _c, _v, data, children = [] } = _vm;

          const {
            class: classNames,
            staticClass,
            style,
            staticStyle,
            attrs = {},
            ...rest
          } = data;

          return _c(
            'svg',
            {
              class: [classNames,staticClass],
              style: [style,staticStyle],
              attrs: Object.assign({"width":"100%","height":"100%","viewBox":"0 0 20 20","fill":"none"}, attrs),
              ...rest,
            },
            children.concat([_c('path',{attrs:{"d":"M8.73451 2.5C8.48135 2.5 8.24193 2.61507 8.08378 2.81275L5.25085 6.35391C5.09271 6.55159 4.85328 6.66667 4.60013 6.66667H1.66732C1.20708 6.66667 0.833984 7.03976 0.833984 7.5V12.5C0.833984 12.9602 1.20708 13.3333 1.66732 13.3333H4.60013C4.85328 13.3333 5.09271 13.4484 5.25085 13.6461L8.08378 17.1872C8.24192 17.3849 8.48135 17.5 8.73451 17.5H11.6673V2.5H8.73451Z","fill":"currentColor"}}),_c('path',{attrs:{"d":"M19.1673 10C19.1673 13.3997 16.6226 16.205 13.334 16.6151V14.9309C15.6987 14.5341 17.5007 12.4775 17.5007 10C17.5007 7.5225 15.6987 5.46586 13.334 5.06913V3.38491C16.6226 3.79499 19.1673 6.60032 19.1673 10Z","fill":"#D8D8D8"}}),_c('path',{attrs:{"d":"M15.834 10C15.834 11.5532 14.7717 12.8583 13.334 13.2283V11.4437C13.8322 11.1555 14.1673 10.6169 14.1673 10C14.1673 9.38309 13.8322 8.84447 13.334 8.5563V6.77168C14.7717 7.14171 15.834 8.4468 15.834 10Z","fill":"#D8D8D8"}})])
          )
        }
      }
    